import request from '@/utils/request'

let BalanceApi = {
  /*编辑*/
  getSetting(data) {
    return request._get('/shop/plus.balance.setting/index', data);
  },

  /*编辑*/
  saveSetting(data) {
    return request._post('/shop/plus.balance.setting/index', data);
  },
}

export default BalanceApi;



// WEBPACK FOOTER //
// ./src/api/balance.js